import React, { Component } from "react";
import * as API from "../api";
import { Modal } from "react-bootstrap";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { AnimatedModal } from "./AnimatedModal";
import { ActivityPopup } from "./ActivityPopup";
import { SetRestrictSesssionExpire } from "../helperComponents/OnIdleHandlerWrapper";
import AppConstants from "../AppConstants";
import ButtonWithIcon from "./ButtonWithIcon";
import { isSelectedDataExceedStorageLimit, convertInMbGB } from "./reusableFunctions";
import { StorageLimitExceed } from "../subscription/UserSubscription";

let prevLoadedData = 0
let chunkSize = 10 * 1024 * 1024;

export default class ZipImporter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      targetFilesArr: [],
      uploaded_data: [],
      imageLimitCount: "0",
      progress: 0,
      _progressInfos: [],
      toShowProgressOf: 0,
      show: false,
      uploadedCount: 0,
      totalImages: 0,
      isCancel: false,
      showCancelPopup: false,
      cancelledAt: 0,
      action: 0,
      currentFileIndex: null,
      lastUploadedFileIndex: null,
      currentChunkIndex: null,
      item: undefined,
      activityPopup: false,
      icon: undefined,
      msg: undefined,
      showActivityPopup: false,
      activityItem: undefined,
      activityIcon: undefined,
      activityMsg: undefined,
      uploadedData: 0,
      uploadFileSize: 0,
      showStorageExceedPopup: false,
    };
  }

  closeActivityPopup = () => {
    this.setState({
      ...this.state,
      showActivityPopup: false,
    })
  }

  cancelUpload = () => {
    SetRestrictSesssionExpire(false)

    prevLoadedData = 0;
    this.setState({
      isCancel: true,
      showCancelPopup: false,
      show: false,
      targetFilesArr: [],
      toShowProgressOf: 0,
      lastUploadedFileIndex: null,
      uploadedCount: 0,
      currentChunkIndex: null,
      currentFileIndex: null,
      uploadCheckPopup: false
    })
  }

  uploadChunk = (readerEvent, fileName, fileSize, currentChunkIndex, currentFileIndex) => {
    const data = new FormData()
    data.append('file', readerEvent)
    data.append('name', fileName);
    data.append('size', fileSize);
    data.append('currentChunkIndex', currentChunkIndex);
    data.append('totalChunks', Math.ceil(fileSize / chunkSize));
    data.append('applicationType', this.props.selectedApplicationType);
    data.append('collectionId', this.props.collectionId)

    if (this.props.fileType === '.zip') {
      if (fileName.toLowerCase().includes(".zip")) {
        API.importZipImages(data).then(response => {
          response.json().then((res) => {
            const chunks = fileSize / chunkSize;
            if (response.status === 200 || response.status === 201) {
              if (currentChunkIndex === Math.ceil(chunks - 1)) {
                prevLoadedData = 0
                this.setState({
                  uploadedData: fileSize,
                  uploadFileSize: fileSize,
                  lastUploadedFileIndex: currentFileIndex,
                  currentChunkIndex: null,
                  toShowProgressOf: ((currentFileIndex + 1) * 100) / this.state.targetFilesArr.length,
                  uploadedCount: (currentFileIndex + 1)
                }, () => {
                  if (this.state.uploadedCount === this.state.targetFilesArr.length) {
                    SetRestrictSesssionExpire(false);
                    this.props.onImageUpload(100);
                  }
                })
              } else {
                let fileUploadedPercentage = currentChunkIndex / chunks * 100
                this.setState({
                  uploadedData: this.state.uploadedData + chunkSize,
                  uploadFileSize: fileSize,
                  toShowProgressOf: this.state.toShowProgressOf < 100 ? this.state.toShowProgressOf + 100 / ((this.state.targetFilesArr.length * 100) / (fileUploadedPercentage - prevLoadedData)) : 100//this.state.toShowProgressOf + (100 / ((this.state.targetFilesArr.length * 100) / fileUploadedPercentage))
                }, () => {
                  this.setState({ currentChunkIndex: currentChunkIndex + 1 })
                  prevLoadedData = fileUploadedPercentage;
                  if (this.state.toShowProgressOf < 0 || this.state.toShowProgressOf === 100) {
                    prevLoadedData = 0
                    this.setState({ toShowProgressOf: 0 });
                  }
                })
              }
            } else if (response.status == 500) {
              this.readAndUploadCurrentChunk();
            } else {
              this.cancelUpload();
              this.setUploadFailedError(res.message || "something went wrong while uploading image.")
            }
          })
        }).catch(error => {
          SetRestrictSesssionExpire(false)
          this.setState({
            ...this.state,
            activityIcon: "ERROR",
            activityMsg: `${error}`,
            showActivityPopup: true,
          });
          this.cancelUpload();
        });
      }
      else {
        this.setState({
          ...this.state,
          activityIcon: "ERROR",
          activityMsg: "Incorrect File, Please choose valid extention file !",
          showActivityPopup: true,
        });
        this.cancelUpload();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentChunkIndex !== this.state.currentChunkIndex && this.state.currentChunkIndex !== null && !this.state.isCancel) {
      this.readAndUploadCurrentChunk();
    }

    if (prevState.currentFileIndex !== this.state.currentFileIndex) {
      if (this.state.currentFileIndex !== null) {
        this.setState({ currentChunkIndex: 0 })
      }
    }

    if (prevState.lastUploadedFileIndex !== this.state.lastUploadedFileIndex) {
      if (this.state.lastUploadedFileIndex === null) {
        return;
      }
      const isLastFile = this.state.lastUploadedFileIndex === this.state.targetFilesArr.length - 1;
      const nextFileIndex = isLastFile ? null : this.state.currentFileIndex + 1;
      this.setState({ currentFileIndex: nextFileIndex })
    }
  }

  readAndUploadCurrentChunk = () => {
    const file = this.state.targetFilesArr[this.state.currentFileIndex];
    if (!file) {
      return;
    } else {
      chunkSize = chunkSize > file.size ? file.size : chunkSize
      const from = this.state.currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      this.uploadChunk(blob, file.name, file.size, this.state.currentChunkIndex, this.state.currentFileIndex);
    }
  }

  // Function to execute when overwrite option is selected
  setUploadFailedError = (msg) => {
    this.setState({
      activityPopup: {
        msg: msg,
        item: "Upload Failed !",
        icon: "ERROR",
        action: "COMPLETE",
      },
      show: false,
      isCancel: true,
    })
  }

  uploadFiles = async () => {
    if (this.state.targetFilesArr.length > 0) {
      if (this.state.currentFileIndex === null) {
        SetRestrictSesssionExpire(true)
        this.setState({
          currentFileIndex: this.state.lastUploadedFileIndex === null ? 0 : this.state.lastUploadedFileIndex + 1,
          toShowProgressOf: 0,
          uploadFileSize: this.state.targetFilesArr[0]?.size,
          show: true,
          uploadCheckPopup: false,
          activityPopup: undefined,
          isCancel: false,
          uploadedCount: 0
        });
      }
    }
  }


  getFilteredFiles = (files) => {
    return (
      files.filter((file) => (file.name.toLowerCase()).includes(".tiff") || (file.name.toLowerCase()).includes(".tif") ||
        (file.name.toLowerCase()).includes(".las") || (file.name.toLowerCase()).includes(".laz") || (file.name.toLowerCase()).includes(".zip"))
    )
  }

  onChangeListenerFile = async (event) => {
    let targetFilesArr = [event.target.files[0]]
    if (targetFilesArr.length > 0) {
      if (await isSelectedDataExceedStorageLimit(targetFilesArr, AppConstants.SERVICES.PICSTORK)) {
        this.setState((state) => ({
          ...state,
          targetFilesArr
        }), () => {
          chunkSize = Math.round(navigator.connection.downlink * 1024 * 1024)
          this.uploadFiles()
        });
      } else { this.setState({ showStorageExceedPopup: true }) }
    }
    else {
      this.setState({
        ...this.state,
        activityIcon: "ERROR",
        activityMsg: "Incorrect File, Please choose valid extention file !",
        showActivityPopup: true,
      });
    }
  }

  onClickListenerFile = (event) => {
    event.target.value = ''
    this.setState({
      uploadedData: 0,
      uploadFileSize: 0,
    })
  }

  close() {
    if (this.state.uploadedCount !== this.state.targetFilesArr.length) {
      this.setState((prevState) => ({
        ...prevState,
        showCancelPopup: true
      }));
    } else {
      this.setState((prevState) => ({
        ...prevState,
        show: this.state.toShowProgressOf >= 100 ? false : true,
        targetFilesArr: [],
        toShowProgressOf: 0,
        lastUploadedFileIndex: null,
        uploadedCount: 0,
        currentChunkIndex: null,
        currentFileIndex: null,
      }));
    }

  }

  hide() {
    this.setState((prevState) => ({
      ...prevState,
      show: this.state.toShowProgressOf >= 100 ? false : true,
    }));
  }

  componentWillUnmount() {
    SetRestrictSesssionExpire(false)
  }

  componentWillMount() {
    var style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = ".popup-content { width: 30% !important; }";
    document.getElementsByTagName("head")[0].appendChild(style);
    let { urls, progress } = this.state;

    this.setState((state) => ({
      ...state,
      urls,
      progress,
    }));
  }
  render() {

    return (
      <>

        {/* -------------- Storage Exceed Popup -------------- */}
        {this.state.showStorageExceedPopup ?
          <StorageLimitExceed seletedDataSize={null} totalStorage={null} onClickOk={() => { this.setState({ showStorageExceedPopup: false }) }} /> : <></>}
        {/* ---------- End Storage Exceed Popup -------------- */}

        <ActivityPopup
          item={this.state.activityItem}
          open={this.state.showActivityPopup}
          icon={this.state.activityIcon}
          // action={this.state.processAction}
          msg={this.state.activityMsg}
          close={() => this.closeActivityPopup()}
          onClickOk={() => {
            this.closeActivityPopup();
          }}
        />
        <React.Fragment>
          <div
            className="add-user-form-text-wrapper"
            style={{ marginTop: "0px" }}
          >
            <input
              name="company_logo"
              id="hiddenFileInputUpload"
              type="file"
              className="add-user-form-file"
              required
              onClick={(event) => this.onClickListenerFile(event)}
              onChange={(e) => {
                this.onChangeListenerFile(e);
              }}
              accept={this.props.fileType}
              multiple={false}
              style={{ display: "none" }}
            />
          </div>

          {this.state.activityPopup ?
            <ActivityPopup
              item={this.state.activityPopup.item}
              open={this.state.activityPopup}
              icon={this.state.activityPopup.icon}
              action={this.state.activityPopup.action}
              msg={this.state.activityPopup.msg}
              close={() => this.setState({ activityPopup: undefined })}
            // onClickOk={() => this.deleteSharedData()}
            /> : <></>}

          <AnimatedModal
            isOpen={this.state.show}
            onRequestClose={() => this.hide()}
            height="300px"
            width="450px"
          >
            <div>
              <div className="services-content-title" style={{ textAlign: 'center', marginTop: '15px' }}>{this.state.toShowProgressOf == 100 ? "Upload Completed !" : this.props.fileType == "PntCld" ? "Uploading File..." : "Uploading Image..."}</div>
              <div style={{}}>
                <div style={{ textAlign: 'center', marginTop: "4%", marginBottom: "2%" }}>
                  <div style={{ width: 175, height: 175, margin: 'auto', fontSize: "10px" }}>
                    <CircularProgressbar
                      value={this.state.toShowProgressOf}
                      text={`${convertInMbGB(this.state.uploadedData)}/${convertInMbGB(this.state.uploadFileSize)}`}
                      styles={{
                        text: {
                          fill: '#2989cf',
                          fontSize: '9px',
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'right', marginTop: '4%', marginRight: '6%' }}>
              <ButtonWithIcon
                text={this.state.uploadedCount === this.state.targetFilesArr.length ? "Close" : "Cancel"}
                width="94px" isBtnActive
                onClick={() => this.close()}
              />
            </div>

          </AnimatedModal>

          <Modal
            style={{ marginTop: '150px' }}
            show={this.state.showCancelPopup}
            onHide={() => {
              this.setState((state) => ({
                ...state,
                showCancelPopup: false,
              }));
            }}
          >
            <Modal.Body >
              <p>Your file upload is still in progress, Are you sure you want to cancel it?</p>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <button
                  className="addcustomer-button-empty-dashboard popup-btn-left btn-ok"
                  onClick={() => {
                    this.setState((state) => ({
                      ...state,
                      showCancelPopup: false,
                      show: true
                    }));
                  }}
                >
                  No
                </button>
              </div>
              <div>
                <button
                  className="add-user-form-submit-button popup-btn-right btn-ok"
                  onClick={() => {
                    this.cancelUpload()
                  }}
                >
                  Yes
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </React.Fragment>
      </>

    );
  }
}
